<template>
  <div>
    <BaseEmploymentsTable
      ref="tableRef"
      data-test="employments-new-table"
      :query="query"
      :is-onboarded="false"
      :has-pending-contract-changes="false"
      :is-active-tab="isActiveTab"
      :bulk-actions="bulkActions"
    >
      <template #action="{ row }">
        <EmploymentActionColumnNew
          :row="row"
          @employment-onboarded="$emit('employment-onboarded')"
        />
      </template>
    </BaseEmploymentsTable>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { TypedQueryDocumentNode } from 'graphql/index'
import BaseEmploymentsTable from './BaseEmploymentsTable.vue'
import { DataTableBulkAction } from '@/components/GraphqlDataTable/types'
import { graphql } from '@/gql'
import EmploymentActionColumnNew from '@/components/GraphqlDataTable/columns/Employment/Partner/EmploymentActionColumnNew.vue'

defineProps<{ isActiveTab?: boolean }>()

const query = graphql(`
  query PartnerEmploymentsNewQuery(
    $accounts: [ID!]
    $search: String
    $first: Int!
    $page: Int
    $orderBy: [EmploymentsOrderByClauseInput!]
    $startDateRange: DateRangeInput
    $endDateRange: DateRangeInput
    $hiringManagers: [ID!]
    $assignmentCompanies: [ID!]
    $locations: [String!]
  ) {
    employments(
      accounts: $accounts
      search: $search
      first: $first
      page: $page
      orderBy: $orderBy
      startDateRange: $startDateRange
      endDateRange: $endDateRange
      hiringManagers: $hiringManagers
      companies: $assignmentCompanies
      locations: $locations
      employerRecordStatus: [INCOMPLETE]
    ) {
      data {
        ...EmploymentWorkerColumn
        ...EmploymentJobColumn
        ...EmploymentContractColumn
        ...EmploymentStartDateColumn
        ...EmploymentEndDateColumn
        ...EmploymentPreviouslyHiredColumn
        ...EmploymentLocationColumn
        ...EmploymentAssignmentCompanyColumn
        ...EmploymentHiringManagerColumn
        ...EmploymentActionColumnNew
      }
    }
  }
`) as TypedQueryDocumentNode

const tableRef = ref<InstanceType<typeof BaseEmploymentsTable> | null>(null)

const bulkActions: DataTableBulkAction[] = []

defineEmits<{
  'employment-onboarded': []
}>()
</script>

<style scoped></style>
